<template>
    <div>
        <button class="navbar-toggler" type="button" aria-expanded="false" aria-label="Toggle navigation"
                @click="open"
        >
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="curtain" v-if="isOpen"></div>

        <div :class="{'nav-actual': 1, 'is-open': isOpen, 'is-closed': !isOpen}">
            <header class="nav-item">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-circle" viewBox="0 0 16 16">
                    <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
                    <path fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"/>
                </svg>
                Hello,
                <strong>
                    <template v-if="username">{{username}}</template>
                    <template v-if="!username">guest</template>
                </strong>
            </header>

            <div class="nav-actual-body">
                <a class="nav-item" :href="popularItemsUrl">Popular</a>
                <a class="nav-item" :href="allItemsUrl">All Items</a>
                <a class="nav-item text-brand" href="/campaigns">Special Deals</a>
                <a class="nav-item" href="/offers/gambody-gift-cards">Gift Cards</a>

                <div class="nav-separator"><div>Shop by Category</div><div class="border"></div></div>

                <template v-for="(item, itemKey) in items">
                    <a v-if="!item.rows" :href="getUrl(item.urls)" class="nav-item">{{item.name}}</a>

                    <div v-if="item.rows && item.rows.length>0"
                         :class="{'nav-item': 1, 'is-open': isItemOpen(item)}"
                         @click="toggleItem(item)">
                        <div class="nav-item-header">
                            <span>{{ item.name }}</span>
                            <chevron-right class="chevron" />
                        </div>
                        <div v-if="item.rows" class="navi-child-container">
                            <a v-for="subitem in item.rows" class="nav-subitem" @click.stop :href="getUrl(subitem.urls)">{{ subitem.name }}</a>
                        </div>
                    </div>
                </template>

                <div class="nav-separator"><div>Bookmarks</div><div class="border"></div></div>

                <a class="nav-item" href="https://www.gambody.com/blog/">Blog</a>
                <a class="nav-item" href="https://gambody.zendesk.com">Help</a>
            </div>

            <button type="button" class="navbar-closer" @click="close">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                    <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                </svg>
            </button>
        </div>
    </div>
</template>

<script>
import ChevronRight from "./icons/ChevronRight.vue";

export default {
    name: "main-nav",

    props: {
        items: { required: true },
        username: {required: true },
        csrf: {},
        premium: {
            type: Boolean,
            default: false
        },
        allItemsUrl: {},
        popularItemsUrl: {},
    },

    components: {
        ChevronRight
    },

    data() {
        return {
            isOpen: false,
            openItems: [],
        }
    },

    mounted() {
        const lsRaw = window.localStorage.getItem("mainNavState");
        if (lsRaw) {
            this.openItems = JSON.parse(lsRaw);
        }
        const that = this
        document.addEventListener("keyup", function(e) {
            if (e.key === "Escape") {
                that.isOpen = false;
            }
        })
    },

    methods: {
        open() {
            this.isOpen = true;
        },

        close() {
            this.isOpen = false;
        },

        isItemOpen(item) {
            return this.openItems.findIndex(e => item.id==e.id)!==-1;
        },

        toggleItem(item) {
            const idx = this.openItems.findIndex(e => item.id==e.id);
            if (idx===-1) {
                this.openItems.push({id: item.id});
            } else {
                this.openItems.splice(idx, 1);
            }

            window.localStorage.setItem("mainNavState", JSON.stringify(this.openItems));
        },

        getUrl(urls) {
            // some categories don't have a stock URL
            return (this.premium || !urls.stock) ? urls.premium : urls.stock;
        }
    }
}
</script>

<style scoped>
form {
    font-family: inherit;
}
.logout-btn {
    cursor: pointer;
    display: block;
    width: 100%;
    text-align: inherit;
    background-color: inherit;
    border: none;
    padding: 0;
    font-size: 1em;
    font-family: Roboto;
}

.nav-item .navi-child-container {
    display: none;
}
.nav-item.is-open .navi-child-container {
    display: flex;
}
.nav-item-header {
    display: flex;
    justify-content: space-between;
}
</style>
